import React from 'react';
import { ServiceFeaturesGrid } from '../common/service-features-grid';

export function DevopsServies() {
    const features = [
        {
            title: 'Continuous Delivery and Integration',
            description:
                'Best-in-class technical architecture across organizations to leverage continuous delivery, build, test, integration, and maintenance along with establishing a close relationship between units.',
            icon: '/img/technology/ic-continues-deliver.svg',
        },
        {
            title: 'Complete Traceability',
            description:
                'Build, code, review, test and repeat the steps until you deliver valuable results by fine-tuning the solution as per the customer\'s expectations. With DevOps, you can perform end-to-end traceability of the project.',
            icon: '/img/technology/ic-traceability.svg',
        },
        {
            title: 'Comprehensive Project Management',
            description:
                'Being one of the best DevOps companies, we provide advanced continuous delivery and integration services to increase efficiency and automation along with streamline production and deployment.',
            icon: '/img/technology/ic-project-management.svg',
        },
        {
            title: 'Deploy Code from Anywhere',
            description:
                'With cloud-based load testing services of Microsoft, you can straightaway connect any code repository or services to cloud with frequent modification anytime, anywhere and from any device.',
            icon: '/img/technology/ic-deployment.svg',
        },
        {
            title: 'Continuous Testing',
            description:
                'With DevOps, you can perform as many tests such as load, unit, performance and UI testing in a continuous order and thus deliver quantifiable results in lesser time.',
            icon: '/img/technology/ic-testing.svg',
        },
        {
            title: 'Faster and Efficient Delivery',
            description:
                'Automating application deployment and testing in a different environment along with racking updates makes software delivery faster yet efficient.',
            icon: '/img/technology/ic-efficient-delivery.svg',
        },
    ];

    return (
        <>
            <div className="section-py bg-grey dark:bg-black">
                <div className="container lg:container mx-auto">
                    <div className="row grid lg:grid-cols-12">
                        <div className="text-center lg:col-span-8 lg:col-start-3 pb-50">
                            <p
                                className="text-primary mb-0 fs-lg fw-700"
                                data-aos="fade-up"
                                data-aos-duration="700"
                                data-aos-delay="200"
                            >
                                We Provide
                            </p>
                            <h2
                                data-aos="fade-up"
                                data-aos-duration="700"
                                data-aos-delay="100"
                            >
                                How DevOps Can Help Your Business to Boost Productivity?
                            </h2>
                        </div>
                    </div>
                <ServiceFeaturesGrid 
                    features={features} 
                    variant="grey"
                />
                </div>
            </div>
        </>
    );
}

export default DevopsServies;